import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Button, message, MessageBox, Row, Col, Tooltip, Alert } from 'kenshin';
import TablePro from '@/components/TablePro';
import { connect, history } from 'umi';
import TreeData from '../../../project/taskManage/components/TreeData';
import { useUpdateEffect } from 'ahooks';
import EllipsisTooltip from '@/components/EllipsisTooltip';
import '../../rptAudit/index.less';
import { SortAscendingOutlined } from '@ant-design/icons';
import ModalFormPro from '@/components/ModalFormPro';
import SortIcon from '@/_assets/icon/sort.js';
import { exportemprptlist } from '@/_serveice/usercenter';
import { downloadXlsx, splitParamsFoGet } from '@/_util/util';
import { timeDiff } from '@/_util';
import { getTaskTagList } from '@/_serveice/project';
// 结构转换给树组件渲染
const transformTreeData = (arr) => {
  return arr?.map((item) => {
    let children = null;
    if (item.childList) {
      children = transformTreeData(item.childList);
    }
    return {
      children,
      title: `${item.servCatgCode} ${item.servCatgName}`,
      key: item.proServCatgId,
      disabled: item.childList?.length > 0,
      ...item,
    };
  });
};

const ServCategory = ({ dispatch, usercenter, project, setTableType }) => {
  // 菜单操作
  const [selectRows, setSelectRows] = useState([]);
  const [selectKeys, setSelectKeys] = useState([]);

  const [moveVisible, setMoveVisible] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [editModalData, setEditModalData] = useState({});
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [taskTagOptions, setTaskTagOptions] = useState([]);
  const [taskMoveTagOptions, setTaskMoveTagOptions] = useState([]);

  const modalRef = useRef();
  const moveModalRef = useRef();

  const projectId = useRef();

  const tableRef = useRef(null);
  const curData = useRef(null); // 存储当前服务类目对应的数据
  const reportDate = useRef();

  useEffect(() => {
    dispatch({
      type: 'project/getusersimpprojectlist',
    });
    // 服务类目
    dispatch({
      type: 'project/getServcatgEasyList',
    });

    return () => {
      dispatch({
        type: 'project/save',
        payload: {
          taskList: {},
          taskListSearchForm: {},
        },
      });
    };
  }, []);

  const showMoveModal = (row) => {
    getProServCatgTree(row.projectId);
    moveModalRef.current?.form?.setFieldsValue({ projectId: row.projectId });
    setSelectKeys([row.rptDetailId]);
    setMoveVisible(true);
  };

  const showEditModal = (row) => {
    setEditModalData(row);
    setEditModalVisible(true);

    modalSetFileds(row);
  };

  // 请求设置修改上报模态窗数据
  const modalSetFileds = ({ rptDetailId, workBeginTime, taskId }) => {
    reportDate.current = workBeginTime;
    const { form } = modalRef.current;
    dispatch({
      type: 'usercenter/getEmpCurTimesLotList',
      payload: {
        empId: localStorage.getItem('muId'),
        reportDate: moment(workBeginTime).format('YYYY-MM-DD'),
      },
    });

    // 获取标签列表
    if (taskId) {
      getTaskTagList({
        type: 3,
        taskId,
        empIdString: localStorage.getItem('muId'),
      }).then((res) => {
        const tagOptions =
          res?.data?.map((item) => ({
            label: item.value,
            value: item.id,
          })) || [];
        setTaskTagOptions(tagOptions);
      });
    }

    dispatch({
      type: 'usercenter/getReportEmpWorkDetail',
      payload: {
        rptDetailId,
      },
    }).then((res) => {
      let data = {
        ...res,
        workTime: [moment(res.workBeginTime), moment(res.workEndTime)],
      };

      form.setFieldsValue(data);
    });
  };

  const columns = [
    {
      dataIndex: 'reportDate',
      width: 150,
      title: '上报日期',
    },
    {
      dataIndex: 'gmtCreate',
      width: 200,
      title: '记录日期',
      render: (time) => moment(time).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'projectName',
      width: 200,
      title: '项目名称',
      render: (row) => `${row.projectName}(${row.contractNumber})`,
    },
    {
      dataIndex: 'proServCatgName',
      width: 200,
      title: '服务类目',
    },
    {
      dataIndex: 'taskName',
      width: 200,
      title: '任务名称',
    },
    {
      dataIndex: 'taskTagName',
      width: 200,
      title: '标签',
    },
    {
      key: 'taskTime',
      title: '具体时间段',
      width: 220,
      render: (row) =>
        [
          moment(row.workBeginTime).format('HH:mm:ss'),
          moment(row.workEndTime).format('HH:mm:ss'),
        ].join(' ~ '),
    },
    // {
    //   dataIndex: 'proServCatgNum',
    //   title: '工作包',
    //   width: 100,
    // },
    {
      dataIndex: 'rptWorkTotalHours',
      title: '上报工时',
      width: 100,
    },
    {
      dataIndex: 'rptRemark',
      title: '上报备注',
      width: 220,
      render: (val) => <EllipsisTooltip value={val} width={200} />,
    },
    {
      title: '操作',
      key: 'options',
      width: 100,
      fixed: 'right',
      render: (row) => {
        return (
          <div>
            <Button type="text" onClick={() => showEditModal(row)}>
              编辑
            </Button>
            <Button type="text" onClick={() => showMoveModal(row)}>
              移动
            </Button>
            <Button
              type="text"
              style={{ color: 'red' }}
              onClick={() => delLog({ rptDetailId: row.rptDetailId })}
            >
              删除
            </Button>
          </div>
        );
      },
    },
  ];

  const searchCloumns = [
    {
      name: 'taskTime',
      type: 'DatePickerRangePicker',
      props: {
        placeholder: ['任务开始时间', '任务结束时间'],
      },
    },
    {
      name: 'taskName',
      type: 'Input',
      props: {
        placeholder: '任务名称',
      },
    },
  ];

  const extra = () => (
    <div style={{ display: 'flex' }}>
      <Button
        type="primary"
        onClick={() => {
          setMoveVisible(true);
        }}
      >
        批量移动
      </Button>

      <Button
        type="primary"
        key="noKeys"
        onClick={() => {
          let value = tableRef.current.value;
          let rptBeginDate = '';
          let rptEndDate = '';
          if (value.workTimeLong) {
            const [start, end] = value.workTimeLong;
            rptBeginDate = moment(start).format('YYYY-MM-DD');
            rptEndDate = moment(end).format('YYYY-MM-DD');
          }
          let payload = {
            key: value.key ?? '',
            rptAuditStatus: value.rptAuditStatus ?? '',
            rptBeginDate,
            rptEndDate,
          };
          let url = `${baseURL}${exportemprptlist}${splitParamsFoGet(payload)}`;
          downloadXlsx(url, '工作记录');
        }}
      >
        导出
      </Button>

      {/* <Button
        type="primary"
        style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}
        onClick={() => setTableType(1)}
      >
        {SortIcon}
        按上报时间显示
      </Button> */}
    </div>
  );

  const onSubmit = (payload) => {
    payload.projectId = projectId.current;
    if (payload.taskTime) {
      const [start, end] = payload.taskTime;
      payload.rptBeginTime = moment(start)
        .startOf('d')
        .format('YYYY-MM-DD HH:mm:ss');
      payload.rptEndTime = moment(end).endOf('d').format('YYYY-MM-DD HH:mm:ss');
    }
    payload.taskTime = undefined;
    if (payload.memberList) {
      payload.memberList = payload.memberList.map((item) => item.split('-')[1]);
    }
  };

  const treeHandleChange = (keys, row) => {
    curData.current = row;
    projectId.current = row.projectId;
    tableRef.current?.reload(
      {
        projectId: row.projectId,
        proServCatgId: row.proServCatgId,
      },
      true,
    );
  };

  /** 根据项目查找工作包 */
  const getProServCatgTree = (projectId) => {
    const { form } = moveModalRef.current;
    form.setFieldsValue({ proServCatgId: undefined, targetTaskId: undefined });

    dispatch({
      type: 'project/getProServcatgTree',
      payload: {
        projectId,
      },
    }).then((data) => {
      setTreeData(transformTreeData(data));
    });
  };

  /** 根据工作包查询任务 */
  const proServChange = (proServCatgId) => {
    dispatch({
      type: 'project/getsimptasklist',
      payload: { proServCatgId },
    }).then((res) => {
      if (res) {
        setTaskList(res);
      }
    });
  };

  /** 根据任务查询标签 */
  const taskChange = (taskId) => {
    getTaskTagList({
      type: 3,
      taskId,
      empIdString: localStorage.getItem('muId'),
    }).then((res) => {
      const tagOptions =
        res?.data?.map((item) => ({
          label: item.value,
          value: item.id,
        })) || [];
      setTaskMoveTagOptions(tagOptions);
    });
  };

  const moveFormItem = [
    {
      render: () => (
        <Alert
          title="操作步骤为选择项目——选择工作包——选择任务，如找不到任务请联系项目经理添加人员"
          type="info"
          showIcon
          closable={false}
        />
      ),
      formItemProps: {
        wrapperCol: 20,
      },
    },
    {
      name: 'projectId',
      label: '项目',
      type: 'Select',
      props: {
        placeholder: '选择项目',
        options: project.userProjectSimpList.map((item) => ({
          label: item.projectName,
          value: item.projectId,
        })),
        onChange: getProServCatgTree,
      },
    },
    {
      name: 'proServCatgId',
      label: '工作包',
      type: 'TreeSelect',
      props: {
        placeholder: '选择工作包',
        treeData,
        onChange: proServChange,
      },
    },
    {
      name: 'targetTaskId',
      label: '任务',
      type: 'Select',
      required: '请选择任务',
      props: {
        placeholder: '请选择任务',
        options: taskList.map((item) => ({
          label: item.value,
          value: item.id,
        })),
        onChange: taskChange,
      },
    },
    {
      name: 'taskTagId',
      label: '标签',
      type: 'Select',
      required: '请选择标签',
      props: {
        placeholder: '请选择标签',
        options: taskMoveTagOptions,
      },
    },
  ];

  const moveModalSave = ({ targetTaskId, taskTagId }) => {
    dispatch({
      type: 'usercenter/moveemprptdata',
      payload: { targetTaskId, rptDetailIdList: selectKeys, taskTagId },
    }).then((res) => {
      if (res) {
        setMoveVisible(false);
        setTaskMoveTagOptions([]);
      }
    });
  };

  const editModalSave = (val) => {
    let payload = {
      ...editModalData,
      ...val,
    };
    if (payload.workTime) {
      let [workBeginTime, workEndTime] = payload.workTime;
      payload.workBeginTime = moment(workBeginTime).format(
        'YYYY-MM-DD HH:mm:ss',
      );
      payload.workEndTime = moment(workEndTime).format('YYYY-MM-DD HH:mm:ss');
      payload.workTime = undefined;
    }
    // 测试 的电脑无法覆盖原数据，强制修改数据
    payload.rptWorkTotalHours = undefined;
    payload.overTimePercent = undefined;
    // 强制修改数据end
    payload.rptWorkTotalHours =
      +payload.rptWorkHours + +payload.rptWorkOvertimeHours;
    payload.overTimePercent =
      (payload.rptWorkOvertimeHours / payload.rptWorkTotalHours).toFixed(2) ||
      0;
    payload.contractNumber = undefined;
    payload.proServCatgAlias = undefined;
    payload.reportDate = undefined;
    payload.projectName = undefined;
    dispatch({
      type: 'usercenter/updateReportEmpWorkDetail_',
      payload: payload,
    }).then((res) => {
      if (res) {
        setEditModalData({});
        setEditModalVisible(false);
      }
    });
  };

  const [datePanelOpen, setDatePanelOpen] = useState(false);
  // 禁用日期
  const disabledDate = useCallback(
    (current) => {
      return (
        current < moment(reportDate.current).startOf('day') ||
        current > moment(reportDate.current).endOf('day')
      );
    },
    [reportDate.current],
  );

  const getTimeAOverTime = (val) => {
    let [start, end] = val;
    let overtime = 0; // 加班占比
    const maxEnd = moment(
      moment(start).set('h', 18).startOf('h').format('YYYY-MM-DD HH:mm:ss'),
    ); // 当天18点后算加班时间
    const minStart = moment(
      moment(start).set('h', 9).startOf('h').format('YYYY-MM-DD HH:mm:ss'),
    ); // 当天9点前算加班时间
    if (end > maxEnd) {
      overtime = timeDiff([start > maxEnd ? start : maxEnd, end]);
      end = maxEnd;
    }
    if (start < minStart) {
      overtime += timeDiff([start, end < minStart ? end : minStart]);
      start = minStart;
    }
    let time = timeDiff([start, end]);
    return {
      time,
      overtime,
    };
  };

  const timeChange = (val) => {
    const { form } = modalRef.current;
    const { time, overtime } = getTimeAOverTime(val);
    form.setFieldsValue({
      rptWorkHours: time,
      rptWorkOvertimeHours: overtime,
    });
  };

  function range(start, end) {
    const result = [];
    for (let i = start; i <= end; i += 10) {
      result.push(i);
    }
    return result;
  }

  // 获取时间禁用的分钟，分钟禁用数量长度超过5则禁用小时（0,10,20,30,40,50）
  const disabledTimeObj = (h) => {
    let start = {},
      end = {};
    const getM = (item) => {
      let sh = moment(item.beginDate).get('h');
      let eh = moment(item.endDate).get('h');
      if (eh > sh) {
        return 60;
      }
      return moment(item.endDate).get('m');
    };
    usercenter.empCurTimesLot
      ?.filter((item) => {
        if (
          item.beginDate == +moment(editModalData.workBeginTime) &&
          item.endDate == +moment(editModalData.workEndTime)
        ) {
          return false;
        }
        return true;
      })
      .map((item) => {
        let sh = moment(item.beginDate).get('h');
        let eh = moment(item.endDate).get('h');
        start[+sh] ||= [];
        end[+eh] ||= [];
        let timeArr = range(moment(item.beginDate).get('m'), getM(item));
        start[+sh] = [...start[+sh], ...timeArr.slice(0, timeArr.length - 1)];
        end[+eh] = [...end[+eh], ...timeArr.slice(1, timeArr.length - 1)];
      });

    const disabledHours = (obj) => () =>
      Object.keys(obj)
        .map((item) => {
          if (obj[item].length >= 5) {
            return +item;
          }
        })
        .filter(Boolean);
    return {
      start: {
        disabledHours: disabledHours(start),
        disabledMinutes: () => start[h],
      },
      end: {
        disabledHours: disabledHours(end),
        disabledMinutes: () => end[h],
      },
    };
  };
  const disabledTime = (date, type) => {
    let curDate = moment(date);
    return disabledTimeObj(curDate.get('h'))[type];
  };

  const workType = [
    {
      label: '正常工作日',
      value: 1,
    },
    {
      label: '有申请加班调休',
      value: 2,
    },
  ];
  const rptworkType = [
    { label: '正常上报', value: 1 },
    { label: '补报', value: 2 },
  ];
  const edtaFormItem = [
    {
      label: '已上报时间段',
      render: () =>
        usercenter.empCurTimesLot?.map((item, i) => {
          let start = moment(item.beginDate).format('YYYY-MM-DD HH:mm:ss');
          let end = moment(item.endDate).format('YYYY-MM-DD HH:mm:ss');
          return (
            <div key={i} style={{ color: '#4389f9' }}>
              {moment(item.beginDate).format('YYYY-MM-DD HH:mm:ss')} ~{' '}
              {moment(item.endDate).format('YYYY-MM-DD HH:mm:ss')}
              <span style={{ marginLeft: 10, color: '#4389f9' }}>
                {item.remark}
              </span>
            </div>
          );
        }),
    },
    {
      name: 'workTime',
      label: '本次上报工时',
      type: 'DatePickerRangePicker',
      props: {
        disabledDate,
        disabledTime,
        onOpenChange: (open) => open && setDatePanelOpen(open),
        onCalendarChange: (dates) => {
          if (dates?.[0] && dates?.[1]) setDatePanelOpen(false);
        },
        open: datePanelOpen,
        showTime: {
          format: 'HH:mm',
          defaultValue: [moment('00', 'ss'), moment('00', 'ss')],
          minuteStep: 10,
        },
        onChange: timeChange,
      },
    },
    {
      name: 'rptWorkHours',
      label: '标准上班工时',
      type: 'Input',
      props: {
        placeholder: '标准上班工时',
        disabled: true,
      },
    },
    {
      name: 'rptWorkOvertimeHours',
      label: '加班工时',
      type: 'Input',
      props: {
        placeholder: '加班工时',
        disabled: true,
      },
    },
    {
      name: 'workHoursType',
      label: '工作类型',
      type: 'RadioGroup',
      props: {
        placeholder: '请输入工作类型',
        options: workType,
      },
    },
    {
      name: 'rptType',
      label: '上报类型',
      type: 'RadioGroup',
      props: {
        placeholder: '请输入上报类型',
        options: rptworkType,
        disabled: true,
      },
    },
    {
      name: 'taskTagId',
      label: '标签',
      type: 'Select',
      required: true,
      props: {
        placeholder: '请选择标签',
        options: taskTagOptions,
        allowClear: false,
      },
    },
    {
      name: 'rptRemark',
      label: '补充说明',
      type: 'TextArea',
      props: {
        placeholder: '请输入补充说明',
      },
    },
  ];

  const delLog = (row) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认删除？删除后无法恢复',
      onOk: () => {
        dispatch({
          type: 'usercenter/deletereportworkdetail_',
          payload: row,
        }).then((res) => {
          if (res) {
            message.success('删除成功');
          }
        });
      },
    });
  };

  return (
    <div className="task-audit">
      <Row gutter="20" style={{ height: '100%' }}>
        <Col span={4}>
          <TreeData onChange={treeHandleChange} />
        </Col>
        <Col span={16}>
          <TablePro
            params={{
              projectId: projectId.current,
              proServCatgId: curData.current?.proServCatgId,
            }}
            request="usercenter/getemprptlistpage"
            rowKey="rptDetailId"
            searchCloumns={searchCloumns}
            columns={columns}
            rowClassName={(row) => (row.taskStatus == 1 ? 'table-success' : '')}
            scrollX
            curColumns
            actionRef={(ref) => (tableRef.current = ref)}
            onSubmit={onSubmit}
            data={usercenter.emprptlistpageList}
            extra={extra}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: selectKeys,
              onChange: (idList, rows) => {
                setSelectKeys(idList);
                setSelectRows(rows);
              },
            }}
          />
        </Col>
      </Row>
      <ModalFormPro
        width={800}
        title="移动"
        visible={moveVisible}
        edtaFormItem={moveFormItem}
        onSave={moveModalSave}
        ref={moveModalRef}
        onCancel={() => {
          setMoveVisible(false);
          setTaskMoveTagOptions([]);
        }}
      />

      <ModalFormPro
        width={800}
        title="编辑"
        visible={editModalVisible}
        edtaFormItem={edtaFormItem}
        formData={editModalData}
        onSave={editModalSave}
        ref={modalRef}
        onCancel={() => {
          setDatePanelOpen(false);
          setEditModalData(null);
          setEditModalVisible(false);
        }}
      />
    </div>
  );
};

export default connect(({ usercenter, project }) => {
  return {
    usercenter,
    project,
  };
})(ServCategory);
